import FileMetaDTO from "@/dto/files/FileMetaDTO";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { SublimeCompanyType } from "@/dto/SublimeCompanyType";

export default class SendSublimeInvoicePayload {
    document: FileMetaDTO | null;
    payerId: number | null;
    payerType: CounterpartyType;
    sublimeCompany: SublimeCompanyType;
    invoiceNumber: string;
    invoiceDate: Date;
    dueDate: Date;
    amount: number | null;
    reference: string;
    paymentLink: string;

    constructor() {
        this.document = null;
        this.payerId = null;
        this.payerType = CounterpartyType.COMPANY;
        this.sublimeCompany = SublimeCompanyType.SUBLIME_CONSULTING;
        this.invoiceNumber = '';
        this.invoiceDate = new Date();
        this.dueDate = new Date();
        this.amount = null;
        this.reference = '';
        this.paymentLink = '';
    }
}